import { PageLayout } from 'src/app/layout/layout.enum';

export const defaultPageOptions = {
  pageProvider: '',
  name: '',
  type: '',
  pageType: PageLayout.Default,
  extraData: {
    title: '',
    id: '',
    path: '',
    components: {
      global: true,
      advantage: true,
      footer: true,
      header: true,
      globalTimer: true,
      newsletter: true,
      breadcrumbs: true,
      customComponents: null,
    },
  },
};
